/**
 * Shared API response helpers. Backend may wrap payload in `body`.
 */

const pickBody = <T>(data: unknown): T => {
  if (data && typeof data === 'object' && 'body' in data) {
    return (data as { body: T }).body;
  }
  return data as T;
};

const getApiErrorMessage = (e: unknown, fallback: string) => {
  const anyErr = e as {
    response?: { data?: { details?: { errors?: unknown[] }; message?: string } };
    message?: string;
  };
  const errors = anyErr?.response?.data?.details?.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const msg = errors
      .map((x) => (x as { message?: string })?.message)
      .filter(Boolean)
      .join('\n');
    if (msg) return msg;
  }
  return anyErr?.response?.data?.message ?? anyErr?.message ?? fallback;
};

export { pickBody, getApiErrorMessage };
